import { IconNoRatingStar, IconRatingStar } from "@repo/assets/images";
const ReviewsList = ({
  item
}) => <li className="border-productDetails-border border-b pb-3" data-sentry-component="ReviewsList" data-sentry-source-file="ReviewsList.jsx">
    <div className="flex py-2">
      {[...Array(5)].map((_, index) => {
      if (index < item.rating) {
        return <IconRatingStar key={index} className="text-productDetails-reviewStar me-1" />; // Filled star
      } else {
        return <IconNoRatingStar key={index} className="text-productDetails-reviewStar me-1 mt-[0.5px]" />; // Empty star
      }
    })}
    </div>
    <p className="text-productDetails-reviewText text-sm font-semibold">
      {item?.customerFirstName} {item?.customerLastName}
    </p>
    <p className="text-productDetails-reviewText pt-3 text-xs">
      {item?.review}
    </p>
  </li>;
export default ReviewsList;